import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles, ArrowRight } from 'lucide-react';
import JourneyLayout from '../../components/JourneyLayout';

function Congratulations() {
  const navigate = useNavigate();

  // Meta Pixel + Google Ads conversion when user lands on Congratulations page
  useEffect(() => {
    // Meta Pixel
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'SP_convcode');
    }

    // Google Ads conversion
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17895773186/PfEICI3s1_MbEIKor9VC',
      });
    }
  }, []);

  return (
    <JourneyLayout showJourneySidebar={false}>
      <div className="text-center space-y-6 py-8">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-20 h-20 rounded-full bg-theme/10 border-2 border-theme/20 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full bg-theme/20 blur-xl" />
            <CheckCircle className="h-10 w-10 text-theme relative" />
          </div>
          <Sparkles className="h-5 w-5 text-theme2" />
        </div>

        <div className="space-y-3">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 font-medium">Final step</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Welcome to Snap Paisa</h1>
          <p className="text-gray-600 max-w-xl mx-auto text-base">
            You've completed every checkpoint. Keep an eye on your account while we prep the disbursal.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 text-left max-w-xl mx-auto">
          <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-5 shadow-sm">
            <p className="text-xs uppercase tracking-[0.15em] text-gray-500 font-medium mb-2">Disbursal Window</p>
            <p className="text-xl font-bold text-gray-900">Within 24 hrs</p>
            <p className="text-gray-600 text-sm mt-1">Funds move post final approval</p>
          </div>
          <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-5 shadow-sm">
            <p className="text-xs uppercase tracking-[0.15em] text-gray-500 font-medium mb-2">Helpdesk</p>
            <p className="text-gray-900 font-semibold text-sm">care@snappaisa.com</p>
            <p className="text-gray-600 text-sm">+91 8750238443</p>
          </div>
        </div>

        <button
          onClick={() => navigate('/dashboard')}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-theme to-theme2 text-white px-8 py-3 rounded-xl font-semibold text-base hover:opacity-90 transition-opacity shadow-md hover:shadow-lg"
        >
          Go to Dashboard
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </JourneyLayout>
  );
}

export default Congratulations;
